import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

interface ReloadErrorResultProps {
  /** Prefixes the `-error` and `-retry` test ids. */
  testId: string;
}

/* For failures nothing on the page can recover from in place, so the retry is a full reload. */
export const ReloadErrorResult = ({ testId }: ReloadErrorResultProps) => {
  const { t } = useTranslation();

  return (
    <Result
      status='error'
      title={t('alert.messages.error')}
      data-testid={`${testId}-error`}
      extra={
        <Button type='primary' data-testid={`${testId}-retry`} onClick={() => globalThis.location.reload()}>
          {t('ai-insights.error.try-again')}
        </Button>
      }
    />
  );
};
